import { html, render, TemplateResult } from 'lit';
import { newGuid } from './view-consts';

// this provides for a single page view accessed by a name.
// launching a page is done via <a href='#${name}' />
export class ViewBase {
  name: string;
  uiid: string = newGuid();
  active: boolean;
  globalRenderEvent: () => Promise<void>;
  constructor(name: string, globalRenderEvent: () => Promise<void>) {
    this.active = false;
    this.uiid = newGuid();
    this.name = name;
    this.globalRenderEvent = globalRenderEvent;
    this.doConstruct();
  }
  protected doConstruct() {}
  public async template(): Promise<TemplateResult> {
    return html`<h1>${this.name}</h1>`;
  }
  protected async onPageActivated(active: Boolean) {}

  public async activatePage() {
    this.active = true;
    await this.onPageActivated(true);
  }
  public async deActivatePage() {
    this.active = false;
    await this.onPageActivated(false);
  }

  protected fallback(first?: string, second?: string) {
    return first && first !== '' ? first : second;
  }
  public async afterRender() {
    await this.onAfterRender();
  }
  protected async onAfterRender() {}

  public async render(): Promise<void> {
    this.globalRenderEvent && (await this.globalRenderEvent());
  }

  protected select2(
    element: HTMLSelectElement,
    options?: any,
    size: string = ''
  ) {
    $(element).each(function () {
      const bs5Options = {
        theme: 'bootstrap-5',
        width: $(this).data('width')
          ? $(this).data('width')
          : $(this).hasClass('w-100')
          ? '100%'
          : 'style',
        placeholder: $(this).data('placeholder'),
        allowClear: false,
        closeOnSelect: true,
        initSelection: function (element, callback) {},

        containerCssClass:
          size == 'small' || size == 'large' ? 'select2--' + size : '',
        selectionCssClass:
          size == 'small' || size == 'large' ? 'select2--' + size : '',
        dropdownCssClass:
          size == 'small' || size == 'large' ? 'select2--' + size : '',
      };
      if (!$(this).hasClass('select2-initialized')) {
        ($(this) as any).select2({ ...options, ...bs5Options });
        $(this).addClass('select2-initialized');
      }
    });
  }
}
